import React from 'react';

import '../../sass/components/charts/RedemptionByHourView.scss';

const COLORS = [
  'rgba(33, 150, 243, 0.1)',
  'rgba(33, 150, 243, 0.3)',
  'rgba(33, 150, 243, 0.6)',
  'rgba(33, 150, 243, 1)',
];

export default class RedemptionByHourView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  renderDayRow = (key, values) => {
    values.length = 24;
    return (
      <div key={key} className='dayRow'>
        <div className='dayTitle'>{key}</div>
        {values.map((e, i) =>
          <div
            key={i}
            className='dayValue'
            style={{
              backgroundColor: COLORS[e < 5 ? 0 : e < 10 ? 1 : e < 15 ? 2 : 3]
            }}
          >
            <div className='tooltip'>{e}</div>
          </div>
        )}
      </div>
    )
  }

  render = () => {
    const keys = Object.keys(this.props.data || {});
    return (
      <div className='redemptionByHourView'>
        <div className='redemptionContent'>
          <div className='headerRow'>
            <label>Day/hour</label>
            {[...Array(12)].map((e, i) =>
              <span key={i}>{`${i*2}`.padStart(2, '0')}:00</span>
            )}
          </div>
          {keys.map(key => this.renderDayRow(key, this.props.data[key]))}
          <div className='scaleInfo'>
            {[...Array(4)].map((e, i) =>
              <div key={i} className='scaleItem'>
                <div
                  className='scaleExample'
                  style={{backgroundColor: COLORS[i]}}
                />
                <span>{i*5}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

}
